import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { relativePath, ROUTES } from '@futrli/shared-services';

import { UsersListContainer } from './containers/users-list-container/users-list-container';
import { WorkspaceListContainer } from './containers/workspace-list-container/workspace-list-container';
import { WorkspacesListContainer } from './containers/workspaces-list-container/workspaces-list-container';

export const WorkspacesRoutes = () => {
  const location = useLocation();

  return (
    <Routes>
      <Route index element={<WorkspacesListContainer />} />

      {/* Redirect any /workspaces/:workspaceId/settings/* routes to /workspaces/:workspaceId/* */}
      {/* Remember - only URLs whitelisted in workspaces-hybrid-router will get to here */}
      <Route
        path={relativePath(ROUTES.WORKSPACE_BY_ID_ROUTE, ROUTES.WORKSPACE_BY_ID_SETTINGS_ROUTE, '/*')}
        element={<Navigate to={location.pathname.replace(ROUTES.WORKSPACE_BY_ID_SETTINGS_ROUTE, '')} />}
      />

      <Route
        path={relativePath(ROUTES.WORKSPACE_BY_ID_ROUTE, ROUTES.ORGANISATIONS_ROUTE)}
        element={<WorkspaceListContainer />}
      />
      <Route
        path={relativePath(
          ROUTES.WORKSPACE_BY_ID_ROUTE,
          ROUTES.ORGANISATIONS_ROUTE,
          ROUTES.ORGANISATIONS_ROUTE
        )}
        element={<WorkspaceListContainer />}
      />
      <Route
        path={relativePath(ROUTES.WORKSPACE_BY_ID_ROUTE, ROUTES.ORGANISATIONS_ROUTE, ROUTES.CONSOLIDATIONS_ROUTE)}
        element={<WorkspaceListContainer />}
      />
      <Route
        path={relativePath(ROUTES.WORKSPACE_BY_ID_ROUTE, ROUTES.USERS_ROUTE)}
        element={<UsersListContainer />}
      />

      <Route
        path={relativePath(ROUTES.WORKSPACE_BY_ID_ROUTE, ROUTES.CONSOLIDATIONS_ROUTE)}
        element={
          <Navigate
            to={`../${relativePath(ROUTES.ORGANISATIONS_ROUTE, ROUTES.CONSOLIDATIONS_ROUTE)}`}
            relative="path"
            replace
          />
        }
      />
      <Route
        path={relativePath(ROUTES.WORKSPACE_BY_ID_ROUTE)}
        element={<Navigate to={relativePath(ROUTES.ORGANISATIONS_ROUTE)} replace />}
      />
    </Routes>
  );
};
